<!-- 查询支付账单信息接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkingCode":"20160723162730110",
                "parkCode":"2KNTYVWC"
            },
            responseCode: {
                "status": 1,
                "resultCode": 0,
                "message": "业务成功",
                "data": {
                    "total": "1",
                    "billList":[{
                        "payValue":"1.00",
                        "disValue":"0.50",
                        "billCode":"123434eew2",
                        "payOrigin":"2",
                        "payOriginRemark":"remark1",
                        "paymentMode":"2",
                        "paymentModeRemark":"remark2"
                    }]
                }
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台查询某个车辆某次停车的缴费记录信息",
                t_url: this.commonUrls.test+"getPayBill",
                p_url: this.commonUrls.prod+"getPayBill",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '否', info3: 'String', info4: '停车场编号' },
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车记录编号' },
                        { info1: 'carCode', info2: '否', info3: 'String', info4: '车牌号' },
                        { info1: 'cardCode', info2: '否', info3: 'String', info4: '停车卡编号' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'total', info2: '是', info3: 'String', info4: '记录条数' },
                        { info1: 'billList', info2: '是', info3: 'JSONArray', info4: '支付账单信息列表' }
                        ]
                },{
                    titleName: 'billList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'payValue', info2: '是', info3: 'Decimal', info4: '支付金额' },
                        { info1: 'disValue', info2: '否', info3: 'Decimal', info4: '优惠金额' },
                        { info1: 'billCode', info2: '是', info3: 'String', info4: '第三方系统缴费订单号' },
                        { info1: 'payDate', info2: '是', info3: 'String', info4: '支付时间，yyyyMMddHHmmss' },
                        { info1: 'payOrigin', info2: '是', info3: 'int', info4: '支付来源，<url>参考附录:/Api/appendixData</url>' },
                        { info1: 'payOriginRemark', info2: '是', info3: 'String', info4: '支付来源备注' },
                        { info1: 'paymentMode', info2: '是', info3: 'String', info4: '支付方式，<url>参考附录:/Api/appendixData</url>' },
                        { info1: 'paymentModeRemark', info2: '是', info3: 'String', info4: '支付方式备注' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/parking/getPayBill.vue